// Is variant reclassification monitoring on for this group? (TGCLOUD-1899.)
//
// THE FLAG. FEATURE_VARIANT_MONITORING, per group and two-tier (backend
// services/variantMonitoring/featureFlag.js): the deployment's licence AND the group's own toggle
// in Settings → Features, off by default. The server sends only features that have a group row,
// so an absent key reads as undefined, and only an explicit true is on. With it off a group's
// families are never swept, no event is written for them, every /variant-reclassification route
// answers 403, and nothing here is drawn: the tile, the nav item, the bell's line, the banner on a
// variant.
import { useContext } from 'react';
import { AppContext } from 'src/store/ContextStore';

/** Is the feature on? Only an explicit true is on. */
export const variantMonitoringOn = (systemFeatures) =>
  systemFeatures?.FEATURE_VARIANT_MONITORING === true;

export function useVariantMonitoringEnabled() {
  const { content } = useContext(AppContext) || {};
  return variantMonitoringOn(content?.settings?.systemFeatures);
}
